import React from 'react';
import MarketCard from './MarketCard';

export interface StripEntry {
  key: string;
  icon?: React.ReactNode;
  name: string;
  price: string;
  changePercent: number;
  meta?: string;
  sparkline?: number[];
  closedAt?: string;
}

interface MarketStripProps {
  entries: StripEntry[];
  accent?: 'neutral' | 'gold';
  selectedKey?: string;
  onSelect?: (key: string) => void;
}

const MarketStrip: React.FC<MarketStripProps> = ({ entries, accent = 'neutral', selectedKey, onSelect }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
    {entries.map((e) => (
      <MarketCard
        key={e.key}
        icon={e.icon}
        label={e.name}
        price={e.price}
        changePercent={e.changePercent}
        meta={e.meta}
        sparkline={e.sparkline}
        closedAt={e.closedAt}
        accent={accent}
        selected={selectedKey === e.key}
        onClick={() => onSelect?.(e.key)}
      />
    ))}
  </div>
);

export default MarketStrip;
